var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "uk-panel uk-panel-box", attrs: { "data-tileid": "200" } },
    [
      _c("div", {
        staticStyle: { "margin-top": "-110px", float: "left" },
        attrs: { id: "affilation-tile-link" },
      }),
      _vm._v(" "),
      _c("h3", { staticClass: "uk-panel-title" }, [
        _c("i", { staticClass: "uk-icon-users" }),
        _vm._v(" "),
        _c(
          "span",
          {
            attrs: {
              "data-include-text": "добавлена",
              "data-exclude-text": "исключена",
            },
          },
          [_vm._v("Аффилированность")]
        ),
        _vm._v(" "),
        _c("i", {
          staticClass: "uk-icon-arrows-alt af-expand",
          staticStyle: {
            cursor: "pointer",
            position: "absolute",
            right: "15px",
            top: "20px",
          },
          attrs: { title: "На весь экран" },
          on: { click: _vm.toggleCanvasSize },
        }),
      ]),
      _vm._v(" "),
      !_vm.auth
        ? _c("p", { attrs: { id: "affilation-tile-demo-msg" } }, [
            _vm._v("В демо-режиме информация не отображается"),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.showFullScreen,
              expression: "showFullScreen",
            },
          ],
        },
        [
          _c(
            "span",
            {
              staticClass: "aff uk-pseudolink af-expand",
              staticStyle: { top: "30px" },
              on: { click: _vm.toggleCanvasSize },
            },
            [
              _vm._v("Свернуть"),
              _c("i", {
                staticClass: "uk-icon-compress",
                staticStyle: { "margin-left": "5px" },
              }),
            ]
          ),
          _vm._v(" "),
          _vm.auth
            ? _c(
                "span",
                {
                  staticClass: "aff uk-pseudolink",
                  staticStyle: { top: "80px" },
                  on: { click: _vm.showLegendToggle },
                },
                [
                  !_vm.showLegend
                    ? _c("span", { staticClass: "affil_legend_full" }, [
                        _vm._v("Показать легенду"),
                        _c("i", {
                          staticClass: "uk-icon-plus-square-o",
                          staticStyle: { "margin-left": "5px" },
                        }),
                      ])
                    : _c("span", { staticClass: "affil_legend_full" }, [
                        _vm._v("Скрыть легенду"),
                        _c("i", {
                          staticClass: "uk-icon-minus-square-o",
                          staticStyle: { "margin-left": "5px" },
                        }),
                      ]),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "span",
            {
              staticClass: "aff uk-pseudolink af-expand affilation-print",
              staticStyle: { top: "110px" },
              on: { click: _vm.printHTML },
            },
            [
              _vm._v("Распечатать"),
              _c("i", {
                staticClass: "uk-icon-print",
                staticStyle: { "margin-left": "5px" },
              }),
            ]
          ),
          _vm._v(" "),
          _c(
            "span",
            {
              staticClass: "aff uk-pseudolink affilation-save",
              staticStyle: { top: "140px" },
              on: { click: _vm.saveAsImage },
            },
            [
              _vm._v("Сохранить"),
              _c("i", {
                staticClass: "uk-icon-save",
                staticStyle: { "margin-left": "5px" },
              }),
            ]
          ),
          _vm._v(" "),
          _vm.auth
            ? _c(
                "span",
                {
                  staticClass: "aff uk-pseudolink afil__resetDefault",
                  staticStyle: { top: "170px" },
                },
                [
                  _vm._v("Сбросить"),
                  _c("i", {
                    class: {
                      "uk-icon-refresh": true,
                      rotating: _vm.resetActive,
                    },
                    staticStyle: { "margin-left": "5px" },
                  }),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "span",
            {
              staticClass: "aff uk-pseudolink afil-show-list",
              staticStyle: { top: "200px" },
              on: { click: _vm.toggleCanvasSize },
            },
            [
              _vm._v("Список "),
              _c("i", {
                staticClass: "uk-icon-file-text-o",
                staticStyle: { "margin-right": "5px" },
              }),
            ]
          ),
          _vm._v(" "),
          _vm._m(0),
        ]
      ),
      _vm._v(" "),
      _vm.auth
        ? _c("div", { attrs: { id: "af-wrap" } }, [
            _c("div", {
              style: _vm.fullScreenStyleObject.af,
              attrs: { id: "af" },
            }),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.showLegend,
              expression: "showLegend",
            },
          ],
          style: _vm.fullLegendStyleObject,
          attrs: { id: "afil-legend" },
        },
        [
          _c("ul", [
            _c("li", { ref: "edge.UPR" }, [
              !_vm.legend.edge.UPR
                ? _c("div", { staticClass: "legend__line-through" })
                : _vm._e(),
              _vm._v(" "),
              _vm._m(1),
              _vm._v(" "),
              _c("div", [_vm._v("Руководитель, УК")]),
            ]),
            _vm._v(" "),
            _c("li", { ref: "edge.UPR_HISTORY" }, [
              !_vm.legend.edge.UPR_HISTORY
                ? _c("div", { staticClass: "legend__line-through" })
                : _vm._e(),
              _vm._v(" "),
              _vm._m(2),
              _vm._v(" "),
              _c("div", [_vm._v("Бывший руководитель")]),
            ]),
            _vm._v(" "),
            _c("li", { ref: "edge.UCHR" }, [
              !_vm.legend.edge.UCHR
                ? _c("div", { staticClass: "legend__line-through" })
                : _vm._e(),
              _vm._v(" "),
              _vm._m(3),
              _vm._v(" "),
              _c("div", [_vm._v("Учредитель")]),
            ]),
            _vm._v(" "),
            _c("li", { ref: "edge.UCHR_HISTORY" }, [
              !_vm.legend.edge.UCHR_HISTORY
                ? _c("div", { staticClass: "legend__line-through" })
                : _vm._e(),
              _vm._v(" "),
              _vm._m(4),
              _vm._v(" "),
              _c("div", [_vm._v("Бывший учредитель")]),
            ]),
            _vm._v(" "),
            _c("li", { ref: "edge.REGISTRY_HOLDER" }, [
              !_vm.legend.edge.REGISTRY_HOLDER
                ? _c("div", { staticClass: "legend__line-through" })
                : _vm._e(),
              _vm._v(" "),
              _vm._m(5),
              _vm._v(" "),
              _c("div", [_vm._v("Реестродержатель")]),
            ]),
            _vm._v(" "),
            _c("li", { ref: "edge.PREDSH" }, [
              !_vm.legend.edge.PREDSH
                ? _c("div", { staticClass: "legend__line-through" })
                : _vm._e(),
              _vm._v(" "),
              _vm._m(6),
              _vm._v(" "),
              _c("div", [_vm._v("Предшественник")]),
            ]),
            _vm._v(" "),
            _c("li", { ref: "edge.PREEM" }, [
              !_vm.legend.edge.PREEM
                ? _c("div", { staticClass: "legend__line-through" })
                : _vm._e(),
              _vm._v(" "),
              _vm._m(7),
              _vm._v(" "),
              _c("div", [_vm._v("Преемник")]),
            ]),
          ]),
          _vm._v(" "),
          _c("ul", [
            _c("li", { ref: "node.ULRos" }, [
              !_vm.legend.node.ULRos
                ? _c("div", { staticClass: "legend__line-through" })
                : _vm._e(),
              _vm._v(" "),
              _c("i", { staticClass: "fa fa-building" }),
              _vm._v(
                "\n                    Юридическое лицо\n                "
              ),
            ]),
            _vm._v(" "),
            _c("li", { ref: "node.ULIn" }, [
              !_vm.legend.node.ULIn
                ? _c("div", { staticClass: "legend__line-through" })
                : _vm._e(),
              _vm._v(" "),
              _c("i", { staticClass: "fa fa-globe" }),
              _vm._v(
                "\n                    Иностранное юридическое лицо\n                "
              ),
            ]),
            _vm._v(" "),
            _c("li", { ref: "node.FL" }, [
              !_vm.legend.node.FL
                ? _c("div", { staticClass: "legend__line-through" })
                : _vm._e(),
              _vm._v(" "),
              _c("i", { staticClass: "fa fa-male" }),
              _vm._v("\n                    Физическое лицо\n                "),
            ]),
            _vm._v(" "),
            _c("li", { ref: "node.IP" }, [
              !_vm.legend.node.IP
                ? _c("div", { staticClass: "legend__line-through" })
                : _vm._e(),
              _vm._v(" "),
              _c("i", { staticClass: "fa fa-user" }),
              _vm._v(
                "\n                    Индивидуальный предп.\n                "
              ),
            ]),
            _vm._v(" "),
            _c("li", { ref: "node.PIF" }, [
              !_vm.legend.node.PIF
                ? _c("div", { staticClass: "legend__line-through" })
                : _vm._e(),
              _vm._v(" "),
              _c("i", { staticClass: "fa fa-university" }),
              _vm._v("\n                    Субъект РФ, ПИФ\n                "),
            ]),
            _vm._v(" "),
            _c("li", { ref: "status.green" }, [
              !_vm.legend.status.green
                ? _c("div", { staticClass: "legend__line-through" })
                : _vm._e(),
              _vm._v(" "),
              _c("div", {
                staticClass: "status-color-block status-color-block__green",
              }),
              _vm._v("\n                    Действущее\n                "),
            ]),
            _vm._v(" "),
            _c("li", { ref: "status.orange" }, [
              !_vm.legend.status.orange
                ? _c("div", { staticClass: "legend__line-through" })
                : _vm._e(),
              _vm._v(" "),
              _c("div", {
                staticClass: "status-color-block status-color-block__orange",
              }),
              _vm._v(
                "\n                    В стадии ликвидации\n                "
              ),
            ]),
            _vm._v(" "),
            _c("li", { ref: "status.red" }, [
              !_vm.legend.status.red
                ? _c("div", { staticClass: "legend__line-through" })
                : _vm._e(),
              _vm._v(" "),
              _c("div", {
                staticClass: "status-color-block status-color-block__red",
              }),
              _vm._v("\n                    Ликвидированое\n                "),
            ]),
          ]),
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticStyle: {
            width: "100%",
            "margin-top": "10px",
            "padding-top": "10px",
          },
        },
        [
          _c(
            "div",
            { staticClass: "uk-button-group affilation-tile_buttons" },
            [
              _c(
                "button",
                {
                  staticClass:
                    "uk-button uk-button-small affilation-tile-show-hide-links",
                  staticStyle: { display: "none" },
                  attrs: { disabled: !_vm.auth },
                },
                [
                  _c("i", {
                    staticClass: "uk-icon-eye-slash",
                    staticStyle: { "margin-right": "5px" },
                  }),
                  _vm._v("Все связи\n                "),
                ]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "uk-button uk-button-small afil__resetDefault",
                  attrs: { disabled: !_vm.auth },
                },
                [
                  _c("i", {
                    class: {
                      "uk-icon-refresh": true,
                      rotating: _vm.resetActive,
                    },
                    staticStyle: { "margin-right": "5px" },
                  }),
                  _vm._v("Сбросить\n                "),
                ]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "afil-show-list uk-button uk-button-small",
                  attrs: { disabled: !_vm.auth },
                },
                [
                  _c("i", {
                    staticClass: "uk-icon-file-text-o",
                    staticStyle: { "margin-right": "5px" },
                  }),
                  _vm._v("Список\n                "),
                ]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "uk-button uk-button-small",
                  on: { click: _vm.showLegendToggle },
                },
                [
                  !_vm.showLegend
                    ? _c("span", [_vm._v("Показать легенду")])
                    : _c("span", [_vm._v("Скрыть легенду")]),
                ]
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "btn-bottom-right uk-button-group",
              attrs: { id: "affilation-save-block" },
            },
            [
              _c(
                "span",
                {
                  staticClass: "uk-button uk-button-small",
                  attrs: { title: "Печатная версия" },
                  on: { click: this.printHTML },
                },
                [_c("i", { staticClass: "uk-icon-print" })]
              ),
              _vm._v(" "),
              _c(
                "span",
                {
                  staticClass: "uk-button uk-button-small",
                  attrs: { title: "Сохранить" },
                  on: { click: this.saveAsImage },
                },
                [_c("i", { staticClass: "uk-icon-save" })]
              ),
            ]
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          style: _vm.fullScreenStyleObject.afTileNodeInfoWrap,
          attrs: { id: "affiliation-tile-node-info-wrap" },
        },
        [
          _vm._m(8),
          _vm._v(" "),
          _c("div", { attrs: { id: "affiliation-tile-node-header" } }),
          _vm._v(" "),
          _c("div", { attrs: { id: "affiliation-tile-node-info" } }),
        ]
      ),
      _vm._v(" "),
      _vm.showModalList
        ? _c(
            "modal",
            {
              attrs: {
                close: function () {
                  _vm.showModalList = false
                },
                printButton: true,
              },
            },
            [
              _c("template", { slot: "modalHeader" }, [
                _vm._v("Список аффилированных лиц. "),
                _c(
                  "span",
                  { staticStyle: { color: "#999", "font-size": "12px" } },
                  [
                    _vm._v(
                      "* в список выведены аффилированные лица, показанные на схеме аффилированности"
                    ),
                  ]
                ),
              ]),
              _vm._v(" "),
              _c(
                "div",
                { attrs: { slot: "modalBody" }, slot: "modalBody" },
                [
                  _c("img", {
                    style: {
                      display: "block",
                      margin: "20px auto",
                      "border-radius": "5px",
                      border: "1px solid #ddd",
                      "max-width": "100%",
                    },
                    attrs: { id: "canvasToImgAsBaseUrl" },
                  }),
                  _vm._v(" "),
                  _vm._l(_vm.modalList, function (e, i) {
                    return _c(
                      "ul",
                      {
                        key: i,
                        staticClass: "affiliantion-modal-list",
                        style: { "margin-left": 5 + 40 * e.level + "px" },
                      },
                      [
                        e.level
                          ? _c(
                              "li",
                              { staticClass: "affiliantion-modal-list__level" },
                              [
                                _vm._v(
                                  "\n                        Уровень " +
                                    _vm._s(e.level) +
                                    "\n                    "
                                ),
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "li",
                          { staticClass: "affiliantion-modal-list__header" },
                          [
                            _c(
                              "span",
                              {
                                staticStyle: {
                                  color: "#aaa",
                                  "font-weight": "500",
                                },
                              },
                              [
                                _vm._v(
                                  "\n                            " +
                                    _vm._s(i + 1) +
                                    ".\n                        "
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            e.ogrn || (e.inn && e.inn.toString().length === 10)
                              ? _c(
                                  "card-link",
                                  { attrs: { ogrn: e.ogrn || e.inn } },
                                  [_vm._v(_vm._s(e.title))]
                                )
                              : e.inn
                              ? _c(
                                  "person-afil",
                                  {
                                    staticClass: "stay-on-this-row",
                                    attrs: { inn: e.inn, fio: e.title },
                                  },
                                  [_vm._v(_vm._s(e.title))]
                                )
                              : _c("span", [_vm._v(_vm._s(e.title))]),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        e.ogrn || e.inn
                          ? _c("li", [
                              e.inn ? _c("b", [_vm._v("ИНН: ")]) : _vm._e(),
                              _vm._v(" "),
                              e.inn
                                ? _c("span", [_vm._v(_vm._s(e.inn))])
                                : _vm._e(),
                              _vm._v(" "),
                              e.ogrn &&
                              e.tooltipData &&
                              e.tooltipData.rec_type == 2
                                ? _c("b", [_vm._v("ОГРНИП: ")])
                                : e.ogrn
                                ? _c("b", [_vm._v("ОГРН: ")])
                                : _vm._e(),
                              _vm._v(" "),
                              e.ogrn
                                ? _c("span", [_vm._v(_vm._s(e.ogrn))])
                                : _vm._e(),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        e.ogrn != null
                          ? [
                              e.tooltipData &&
                              (e.tooltipData.date_start ||
                                e.tooltipData.date_stop)
                                ? _c("li", [
                                    _c("span", {
                                      domProps: {
                                        innerHTML: _vm._s(
                                          _vm.getStatusIcon(
                                            e.tooltipData.status_type
                                          )
                                        ),
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "i",
                                      {
                                        staticStyle: {
                                          "padding-left": "2px",
                                          "font-style": "italic",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "\n                                " +
                                            _vm._s(
                                              _vm.statusTypeText(
                                                e.tooltipData.status_type
                                              )
                                            ) +
                                            "\n                                " +
                                            _vm._s(
                                              e.tooltipData.date_stop
                                                ? new Date(
                                                    e.tooltipData.date_stop
                                                  ).toLocaleDateString()
                                                : new Date(
                                                    e.tooltipData.date_start
                                                  ).toLocaleDateString()
                                            ) +
                                            "\n                            "
                                        ),
                                      ]
                                    ),
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              e.tooltipData && e.tooltipData.addr_full
                                ? _c("li", [
                                    _c("b", [_vm._v("Адрес: ")]),
                                    _vm._v(" "),
                                    _c("span", [
                                      _vm._v(_vm._s(e.tooltipData.addr_full)),
                                    ]),
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              e.tooltipData &&
                              e.tooltipData.upr &&
                              e.tooltipData.upr.length
                                ? _c(
                                    "li",
                                    [
                                      e.tooltipData.upr[0].position
                                        ? _c("b", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.lowerButFirst(
                                                  e.tooltipData.upr[0].position
                                                )
                                              ) + ": "
                                            ),
                                          ])
                                        : _c("b", [_vm._v("Руководитель: ")]),
                                      _vm._v(" "),
                                      e.tooltipData.upr[0].ogrn ||
                                      (e.tooltipData.upr[0].inn &&
                                        e.tooltipData.upr[0].inn.toString()
                                          .length === 10)
                                        ? _c(
                                            "card-link",
                                            {
                                              attrs: {
                                                ogrn:
                                                  e.tooltipData.upr[0].ogrn ||
                                                  e.tooltipData.upr[0].inn,
                                              },
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  e.tooltipData.upr[0].name
                                                )
                                              ),
                                            ]
                                          )
                                        : e.tooltipData.upr[0].inn
                                        ? _c(
                                            "person-afil",
                                            {
                                              staticClass: "stay-on-this-row",
                                              attrs: {
                                                inn: e.tooltipData.upr[0].inn,
                                                fio: e.tooltipData.upr[0].name,
                                              },
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.lowerButFirstSentence(
                                                    e.tooltipData.upr[0].name
                                                  )
                                                )
                                              ),
                                            ]
                                          )
                                        : _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.lowerButFirstSentence(
                                                  e.tooltipData.upr[0].name
                                                )
                                              )
                                            ),
                                          ]),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              e.tooltipData &&
                              e.tooltipData.uchr &&
                              e.tooltipData.uchr.length
                                ? _c(
                                    "li",
                                    [
                                      _c("b", [_vm._v("Собственники: ")]),
                                      _vm._v(" "),
                                      _vm._l(
                                        e.tooltipData.uchr.filter(function (
                                          e,
                                          i
                                        ) {
                                          return i < 5
                                        }),
                                        function (uchrElm, uchrIndex) {
                                          return _c(
                                            "span",
                                            { key: uchrIndex },
                                            [
                                              uchrElm.ogrn ||
                                              (uchrElm.inn &&
                                                uchrElm.inn.toString()
                                                  .length === 10)
                                                ? _c(
                                                    "card-link",
                                                    {
                                                      attrs: {
                                                        ogrn:
                                                          uchrElm.ogrn ||
                                                          uchrElm.inn,
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(uchrElm.name)
                                                      ),
                                                    ]
                                                  )
                                                : uchrElm.inn
                                                ? _c(
                                                    "person-afil",
                                                    {
                                                      staticClass:
                                                        "stay-on-this-row",
                                                      attrs: {
                                                        inn: uchrElm.inn,
                                                        fio: uchrElm.name,
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(uchrElm.name)
                                                      ),
                                                    ]
                                                  )
                                                : _c("span", [
                                                    _vm._v(
                                                      _vm._s(uchrElm.name)
                                                    ),
                                                  ]),
                                              _vm._v(" "),
                                              uchrIndex !=
                                              e.tooltipData.uchr.filter(
                                                function (e, i) {
                                                  return i < 5
                                                }
                                              ).length -
                                                1
                                                ? _c(
                                                    "span",
                                                    {
                                                      staticStyle: {
                                                        "margin-left": "-2px",
                                                      },
                                                    },
                                                    [_vm._v(", ")]
                                                  )
                                                : _vm._e(),
                                            ],
                                            1
                                          )
                                        }
                                      ),
                                    ],
                                    2
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              e.tooltipData && e.tooltipData.okved_title
                                ? _c("li", [
                                    _c("b", [_vm._v("ОКВЭД: ")]),
                                    _vm._v(
                                      "\n                            " +
                                        _vm._s(e.tooltipData.okved_title) +
                                        "\n                        "
                                    ),
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              e.tooltipData && e.tooltipData.auth_capital
                                ? _c("li", [
                                    _c("b", [_vm._v("Уставный капитал: ")]),
                                    _vm._v(
                                      "\n                            " +
                                        _vm._s(
                                          _vm.moneyFormat(
                                            e.tooltipData.auth_capital
                                          )
                                        ) +
                                        " "
                                    ),
                                    _c("i", { staticClass: "uk-icon-rub" }),
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              e.tooltipData &&
                              e.tooltipData.fin_years &&
                              e.tooltipData.fin_rations &&
                              e.tooltipData.fin_rations.viruchka &&
                              e.tooltipData.fin_years.length
                                ? _c("li", [
                                    _c("b", [
                                      _vm._v(
                                        "Выручка за " +
                                          _vm._s(
                                            e.tooltipData.fin_years[
                                              e.tooltipData.fin_years.length - 1
                                            ]
                                          ) +
                                          " год:"
                                      ),
                                    ]),
                                    _vm._v(
                                      "\n                            " +
                                        _vm._s(
                                          _vm.moneyFormat(
                                            e.tooltipData.fin_rations.viruchka
                                          )
                                        ) +
                                        " "
                                    ),
                                    _c("i", { staticClass: "uk-icon-rub" }),
                                  ])
                                : _vm._e(),
                            ]
                          : _vm._e(),
                      ],
                      2
                    )
                  }),
                ],
                2
              ),
            ],
            2
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "span",
      {
        staticClass: "aff uk-pseudolink affilation-tile-show-hide-links",
        staticStyle: { top: "230px" },
      },
      [
        _vm._v("Все связи"),
        _c("i", {
          staticClass: "uk-icon-eye-slash",
          staticStyle: { "margin-left": "5px" },
        }),
      ]
    )
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "afil-legend-edge afil-legend-edge__upr" },
      [_c("div", { staticClass: "afil-legend-edge__text" })]
    )
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "afil-legend-edge afil-legend-edge__lupr" },
      [_c("div", { staticClass: "afil-legend-edge__text" })]
    )
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "afil-legend-edge afil-legend-edge__uchr" },
      [_c("div", { staticClass: "afil-legend-edge__text" }, [_vm._v("100%")])]
    )
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "afil-legend-edge afil-legend-edge__luchr" },
      [_c("div", { staticClass: "afil-legend-edge__text" }, [_vm._v("Учр.")])]
    )
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "afil-legend-edge afil-legend-edge__reestr" },
      [
        _c("div", { staticClass: "afil-legend-edge__text" }, [
          _vm._v("Реестродерж."),
        ]),
      ]
    )
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "afil-legend-edge afil-legend-edge__predsh" },
      [_c("div", { staticClass: "afil-legend-edge__text" }, [_vm._v("Предш")])]
    )
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "afil-legend-edge afil-legend-edge__preem" },
      [_c("div", { staticClass: "afil-legend-edge__text" }, [_vm._v("Преем.")])]
    )
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { attrs: { id: "affiliation-tile-node-info-close" } }, [
      _c("i", { staticClass: "uk-close" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }